<template>
  <div class="task-course-cell" @click="courseTaskClick">
    <div class="tag">
      <img class="course-img" src="../../../assets/images/home/course.png" />
    </div>
    <div class="right-content" :class="{ 'hide-bottom-line': hideBottomLine }">
      <div class="task-name-wrap" v-if="taskData.courseType == 2">
        <div class="task-name-long" :style="{ color: '#1f333f' }">
          {{ taskData && taskData.courseDisplayName }}
        </div>
        <div class="courseType">选修</div>
      </div>
      <div v-else class="task-name" :style="{ color: '#1f333f' }">
        {{ taskData && taskData.courseDisplayName }}
      </div>
      <div class="task-state-label">
        <div class="label-item">
          <div class="click-btn">
            去学习
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {isScorm} from '../../../api/scorm'

export default {
  name: 'TaskCellLite',
  props: {
    taskData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    hideBottomLine: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    async courseTaskClick() {
      window.sessionStorage.setItem('entrance', '12')
      const query = {
        trainTaskId: this.taskData.id || '',
        trainId: this.taskData.trainId || '',
        studyState: this.taskData.studyState,
        courseEType: this.taskData.courseEtype,
        studentUserId: this.userInfo ? this.userInfo : '',
        courseId: this.taskData.courseId,
        journeyId: this.taskData.journeyId,
        businessId: this.taskData.journeyId,
        entrance: '12',
        channel: '12'
      }
      const isscorm = await isScorm(this.taskData.courseId)
      let path = '/courserDetails'
      if (isscorm.data) {
        path = '/scormCourseDetail'
      }
      this.$router.push({path, query})
    }
  }
}
</script>

<style lang="less" scoped>
.task-course-cell {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #1f333f;
  height: 48px;
  line-height: 48px;
  position: relative;
  .tag {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 13px;
    width: 32px;
    height: 16px;
    .course-img {
      width: 100%;
      height: 100%;
    }
  }
  .right-content {
    flex: 1;
    display: flex;
    align-items: center;
    width: calc(100% - 45px);
    &.hide-bottom-line {
      border-bottom: none;
    }
    .task-name {
      margin-right: 3px;
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 160px;
      height: 17px;
      font-size: 12px;
      font-family: AppleSystemUIFont;
      color: #1f262f;
      line-height: 17px;
    }
    .task-name-wrap {
      margin-right: 13px;
      flex: 1;
      display: flex;
      align-items: center;
      .task-name-long {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100px;
        height: 17px;
        font-size: 12px;
        font-family: AppleSystemUIFont;
        color: #1f262f;
        line-height: 15px;
        flex: 1;
      }
      .courseType {
        padding: 3px 5px;
        background: #f4f4f4;
        border-radius: 4px;
        font-size: 10px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        color: #999999;
        line-height: 1;
        margin-left: 10px;
      }
    }
    .task-state-label {
      .label-item {
        display: flex;
        align-items: center;
        .click-btn {
          padding: 2px 7px;
          color: #ffffff;
          background: #EB1700;
          border-radius: 20px;
          font-size: 10px;
          font-weight: 500;
          line-height: 16px;
          width: 30px;
        }
        .finish-icon {
          width: 16px;
          height: 16px;
        }
        .state-label-text {
          font-size: 11px;
          font-weight: 500;
          color: #EB1700;
        }
        .course-opened-icon {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/TaskCellLite.vue